<script lang="ts">
    import {SuggestType} from "../../constants/suggestType";
    import SuggestionList from "./SuggestionList.svelte";
    import TrendingQueryList from "./TrendingQueryList.svelte";
    import NavSlider from "./navSlider/NavSlider.svelte";
    import {suggestType} from "../../store/Derived";
    import {SqrlTestId} from "../../constants/squirrel";
    import HistoryList from "./history/HistoryList.svelte";
    import LastSeenCinema from "./lastSeenCinema/LastSeenCinema.svelte";
    import {suggestLayer} from "./SuggestLayer";
    import {SQRL_EVENT} from "../../events/sqrlEvents";
    import {tracking} from "../../tracking/Tracking";
    import {onSuggestShown} from "../../index";

    /**
 *
 *
 */
    function trackSuggestLayerShown(node: HTMLElement) {
        suggestLayer.trackShownOnce(() => {
            tracking.trackCreateEventContext(SQRL_EVENT.SUGGEST_SHOWN, onSuggestShown);
        });
    }
</script>

<div
        class="squirrel_searchSuggestionsContainer js_squirrel_searchSuggestionsContainer"
        data-qa-id="search-suggestions"
        data-suggestserveruri="/san-squirrel-suggest-api/completion"
        data-testid={SqrlTestId.SUGGEST_LAYER}
        use:trackSuggestLayerShown
>
    {#if $suggestType === SuggestType.SUGGEST}
        <SuggestionList/>
    {:else if $suggestType === SuggestType.HYBRID}
        <NavSlider/>
        <HistoryList/>
    {:else if $suggestType === SuggestType.TRENDING_QUERY}
        <NavSlider/>
    {/if}
    <!-- Never re-render last seen cinema component -->
    <LastSeenCinema/>

    <!-- Always show Trending query list after last seen cinema -->
    {#if $suggestType === SuggestType.HYBRID || $suggestType === SuggestType.TRENDING_QUERY}
        <TrendingQueryList/>
    {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "@otto-ec/otto-components-utils/scss/_mixins/breakpoint";
  @use "../../styles/constants";

  .squirrel_searchSuggestionsContainer {
    width: 100%;
    position: absolute;
    left: tokens.$oc-semantic-spacing-0;
    z-index: 101;
    height: fit-content;
    overflow: hidden;

    @include breakpoint.breakpoint-from-l($to: false) {
      top: tokens.$oc-base-dimension-72;
      border-bottom-left-radius: tokens.$oc-semantic-border-radius-100;
      border-bottom-right-radius: tokens.$oc-semantic-border-radius-100;
    }
  }
</style>
